import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import participantGroupApiClient from "Services/Apis/ParticipantGroup/participantGroupApiClient";

export const getParticipantGroupThunk = createAsyncThunk(
  "GetParticipantGroupSlice/getParticipantGroupThunk",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { user } = getState().oidc;

      const headers = {
        Authorization: `Bearer ${user.access_token}`,
        campaignId: user.profile["custom:campaign_id"],
        catalogId: user.profile["custom:catalog_id"],
        participantId: user.profile["custom:participant_id"],
      };
  
      const config = { headers };
  
      const { data } = await participantGroupApiClient.get(
        "/participantGroup",
        config
      );
  
      return data;
    } catch (err) {
      if (err.response) return rejectWithValue(err.response);
    }
  }
);

const initialState = {
  participantGroups: null,
  isParticipantGroupLoading: false,
  participantGroupHasError: false,
};

const getParticipantGroupSlice = createSlice({
  name: "GetParticipantGroupSlice",
  initialState,
  reducers: {
    resetParticipantGroupData: (state) => {
      state.participantGroups = null;
      state.isParticipantGroupLoading = false;
      state.participantGroupHasError = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getParticipantGroupThunk.pending, (state) => {
      state.participantGroups = null;
      state.isParticipantGroupLoading = true;
      state.participantGroupHasError = false;
    });
    builder.addCase(getParticipantGroupThunk.fulfilled, (state, action) => {
      state.participantGroups = action.payload;
      state.isParticipantGroupLoading = false;
      state.participantGroupHasError = false;
    });
    builder.addCase(getParticipantGroupThunk.rejected, (state, action) => {
      state.participantGroups = null;
      state.isParticipantGroupLoading = false;
      state.participantGroupHasError = action.payload;
    });
  },
});

export const { resetParticipantGroupData } = getParticipantGroupSlice.actions;
export default getParticipantGroupSlice.reducer;
